import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { TiInfoOutline } from "react-icons/ti";
import { useSelector, useDispatch } from "react-redux";
import { BiShow } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import ContractFileUpload from "../ContractFileUpload";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import Highlighter from "react-highlight-words";

const ContractFilesTable = ({ contractDetails, updateComponent }) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [selectedFileType, setSelectedFileType] = useState("CONTRACT FILE");
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);

  const [contractFileUploadState, setContractFileUploadState] = useState({
    open: false,
    type: selectedFileType,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (contractDetails?.contract_file?.length != 0) {
      const files = contractDetails?.contract_file?.filter(
        (f) => f.type === selectedFileType
      );
      setFilteredFiles(files);
    } else {
      setFilteredFiles([]);
    }
  }, [selectedFileType, contractDetails?.contract_file]);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filteredFiles);

  const dashboardData = useSelector((state) => state.dashboardData);
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    fileId: "",
  });
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const deleteFile = async () => {
    setDeleteLoading(true);
    try {
      const res = await axios.delete(
        `/dashboard/contract/file-delete/${showPromptElement?.fileId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        dispatch(setAppError({ msg: res?.data?.message, color: "success" }));
        updateComponent((p) => !p);
        setDeleteLoading(false);
        setShowPromptElement({ open: false, fileId: "" });
      }
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
    }
  };

  const [searchWords, setSearchWords] = useState([]);

  return (
    <>
      {showPromptElement.open && (
        <div
          className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
            showPromptElement.open ? "flex" : "hidden"
          }`}
        >
          <div className="max-w-sm w-full h-auto uppercase  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
            <TiInfoOutline className="text-center text-red" size={"3rem"} />
            <h2 className="text-xl font-medium p-4 pb-1 text-center">
              Are you sure ?
            </h2>
            <p>You won't be able to revert this!</p>
            <div className="flex gap-3 min-w-fit m-5">
              <button
                className="p-1 w-20 uppercase rounded-md ring-1 ring-slate-600"
                onClick={() => {
                  setShowPromptElement({ open: false, fileId: "" });
                }}
              >
                Cancel
              </button>
              <button
                disabled={deleteLoading}
                className="p-1 w-20 uppercase rounded-md ring-1 ring-red text-white bg-red"
                onClick={() => deleteFile()}
              >
                {deleteLoading ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {contractFileUploadState.open && (
        <ContractFileUpload
          showPromptElement={contractFileUploadState}
          setShowPromptElement={setContractFileUploadState}
          updateComponent={updateComponent}
          start_date={contractDetails.start_date}
          end_date={contractDetails.end_date}
          original_term={contractDetails.term}
          contractDetails={contractDetails}
        />
      )}
      <div
        className={` bg-slate-50 shadow-md rounded-lg px-1 transition-all w-full min-w-full py-5 h-auto my-4`}
      >
        <div className="flex flex-wrap  min-w-full w-full gap-2 items-center bg-slate-200 p-2 rounded-md">
          {[
            "CONTRACT FILE",
            "ANNEXURE FILE",
            "COC FILE",
            "ORGINAL DOC",
            "OTHERS",
          ].map((e, i) => (
            <button
              key={i}
              className={`p-2 rounded-md w-40  ${
                selectedFileType === e
                  ? "bg-red text-white"
                  : "bg-white text-black"
              }`}
              onClick={() => {
                setFilesLoading(true);
                setSelectedFileType(e);
                setTimeout(() => {
                  setFilesLoading(false);
                }, 500);
              }}
            >
              {e}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap w-full justify-between items-center">
          <Search
            searchKey={["file_name", "description", "date"]}
            className={"max-w-fit"}
            setSearchWords={setSearchWords}
          />

          <div className="flex justify-end p-3 min-w-fit">
            {checkAccess("Contract", "contract-create") && (
              <button
                className="p-2 rounded-md bg-red text-white text-sm my-2 self-end"
                onClick={() =>
                  setContractFileUploadState((p) => ({
                    open: true,
                    type: selectedFileType,
                  }))
                }
              >
                Upload File
              </button>
            )}
          </div>
        </div>
        <CountPerPage />
        <div
          className={`grid justify-items-center grid-cols-table-5 auto-cols-min gap-5 p-6 bg-white   items-baseline w-full overflow-x-scroll lg:overflow-auto  rounded-md `}
        >
          {[
            "S.No.",
            "File Name",
            "Description",
            "UPLOAD DATE & TIME",
            "Action",
          ].map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {filesLoading && (
            <>
              <div className="flex justify-center bg-slate-100 h-8 items-center gap-3 w-11/12 col-span-5">
                {/* <p>Loading</p> */}
                {/* <CgSpinner className="animate-spin" /> */}
              </div>
              <div className=" bg-slate-100 h-8  w-11/12 col-span-5"></div>
              <div className=" bg-slate-100 h-8  w-11/12 col-span-5"></div>
              <div className=" bg-slate-100 h-8  w-11/12 col-span-5"></div>
              <div className=" bg-slate-100 h-8  w-11/12 col-span-5"></div>
            </>
          )}
          <NoDataFound />
          {currentList?.map((list, index) => (
            <React.Fragment key={index}>
              {!filesLoading && (
                <>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.file_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.description || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list?.date || "-"}
                    />
                  </p>

                  <div className="flex gap-3 min-w-fit ">
                    {/* {checkAccess("Contract", "company-edit") ? ( */}
                    <a
                      href={list?.file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="p-1 px-2 rounded-md ring-1 ">
                        <BiShow size={"1.4rem"} />
                      </button>
                    </a>
                    {checkAccess("Contract", "contract-delete") && (
                      <button
                        onClick={() =>
                          setShowPromptElement({ open: true, fileId: list?.id })
                        }
                        className="p-1 px-2 rounded-md ring-1 bg-red text-white "
                      >
                        <MdDeleteOutline size={"1.4rem"} />
                      </button>
                    )}
                  </div>
                </>
              )}

              <hr className="border-[1.5px] border-slate-100  w-full col-span-5" />
            </React.Fragment>
          ))}
        </div>
        <Pagination />
      </div>
    </>
  );
};

export default ContractFilesTable;
